export function toDollar(amount) {
  return parseFloat(amount).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}

export function toDollarSmall(amount) {
  const num = parseFloat(amount);
  // Work with the absolute value to determine the magnitude, but preserve the sign for output
  const absNum = Math.abs(num);

  if (absNum >= 10) {
    // Large values – defer to the regular dollar formatter (2 decimals + commas)
    return toDollar(num);
  } else if (absNum >= 1) {
    // Values between 1 and 10 – 2 decimal places
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  } else if (absNum >= 0.0001) {
    // Medium-small values – 4 decimal places
    return num.toFixed(4).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  } else if (absNum >= 0.00000001) {
    // Very small values – 8 decimal places
    return num.toFixed(8).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  } else {
    // Extremely small – fall back to scientific notation to avoid an unwieldy string
    return num.toExponential(8);
  }
}

export function toAbbreviatedDollar(amount) {
  const num = parseFloat(amount);
  
  if (isNaN(num)) return '0';
  
  const absNum = Math.abs(num);
  const sign = num < 0 ? '-' : '';
  
  if (absNum >= 1e12) {
    // Trillions
    return sign + (absNum / 1e12).toFixed(1) + 'T';
  } else if (absNum >= 1e9) {
    // Billions
    return sign + (absNum / 1e9).toFixed(1) + 'B';
  } else if (absNum >= 1e6) {
    // Millions
    return sign + (absNum / 1e6).toFixed(1) + 'M';
  } else if (absNum >= 1e3) {
    // Thousands
    return sign + (absNum / 1e3).toFixed(1) + 'K';
  } else {
    // Less than 1000, show as is with 2 decimal places
    return sign + absNum.toFixed(2);
  }
}

export function toDollar_NoCents(amount) {
  return (parseInt(amount, 10)+'').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
}

export function getBs58(input){
  const regex = /[13][a-km-zA-HJ-NP-Z0-9]{26,34}/i
  var exp = input.match(regex);

  if (exp != null)
  	return exp[0]
  else
  	return null


}

export function getBc32(input){
  const regex = /bc1[a-km-zA-HJ-NP-Z0-9l]{1,90}/i
  var exp = input.match(regex);

  if (exp != null)
  	return exp[0]
  else
  	return null
}

export function minimizeToken(token, type = '') {
  if(!token) {
    return `no ${type} token`;
  }

  return `${token.substring(0, 6)}...${token.substring(token.length - 6, token.length)}`;
}

export function truncateBtcAmount(number, decimalPlaces) {
  const factor = Math.pow(10, decimalPlaces);
  const truncatedValue = Math.trunc(number * factor) / factor;
  return truncatedValue.toString() + '...';
}
